import React, { forwardRef } from "react";

import { CardComponent } from "@chargebee/chargebee-js-react-wrapper";

import { useChargebeeJS } from "components/Chargebee";

import { CreditCardFields } from "./components";

export function PaymentInformation(props, tokenizeRef) {
  const { loading, error } = useChargebeeJS();

  if (error) {
    return (
      <p>
        An unexpected error occurred with our payment provider. Please try
        refreshing your browser or contact our customer support for assistance.
      </p>
    );
  }

  if (loading) return null;

  return (
    <CardComponent ref={tokenizeRef}>
      <CreditCardFields {...props} />
    </CardComponent>
  );
}

export default forwardRef(PaymentInformation);
